module.exports = __webpack_public_path__ + "static/media/leadPages.4a47401c.svg";